import styled from 'styled-components';

import { AssignList } from '@components/assign-button';
import { IconAssign } from '@components/icons/assign';
import { IconPerson } from '@components/icons/person';
import { StatusIndicator, StatusIndicatorProps } from '@components/status-indicator';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import type { JourneyNode } from './types';

const AssigneesContainer = styled.div({ display: 'flex' });

const MAX_VISIBLE_ASSIGNEES = 3;
const MAX_VISIBLE_ASSIGNEES_WITH_OVERFLOW = MAX_VISIBLE_ASSIGNEES - 1;

const OverflowCount = styled.div({
  width: pxToRem(32),
  height: pxToRem(32),
  borderRadius: '50%',
  border: `${pxToRem(2)} solid ${theme.color.border10}`,
  backgroundColor: theme.color.backgroundLightDark,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  font: theme.font.semibold12,
  color: theme.color.textSecondary,
  flexShrink: 0,
});

type AssigneesProps = Partial<StatusIndicatorProps> & {
  assignees: JourneyNode['data']['assignees'];
};

export const Assignees = ({
  assignees = [],
  variant = 'notStarted',
  ratio,
  icon = <IconPerson />,
  tooltip,
  ...rest
}: AssigneesProps) => {
  return (
    <AssigneesContainer {...rest}>
      <AssignList>
        {assignees.length === 0 ? (
          <AssignList.Icon icon={<IconAssign />} />
        ) : (
          <>
            {assignees.length > MAX_VISIBLE_ASSIGNEES && (
              <OverflowCount>
                +{assignees.length - MAX_VISIBLE_ASSIGNEES_WITH_OVERFLOW}
              </OverflowCount>
            )}
            {assignees
              .slice(
                0,
                assignees.length > MAX_VISIBLE_ASSIGNEES
                  ? MAX_VISIBLE_ASSIGNEES_WITH_OVERFLOW
                  : MAX_VISIBLE_ASSIGNEES
              )
              .map((user) => (
                <AssignList.Avatar key={user.id} assignee={user} />
              ))}
          </>
        )}
        <div style={{ zIndex: 1 }}>
          <StatusIndicator variant={variant} icon={icon} ratio={ratio} tooltip={tooltip} />
        </div>
      </AssignList>
    </AssigneesContainer>
  );
};
